import { TraitTypeColor } from '../traitTypes/TraitTypeColor';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { calculateFixpoint } from './TraitRegistryCssTransform';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryCssBox extends TraitRegistryCategory {
    label = 'Box';
    constructor(parent) {
        super(parent);
        super.init();
    }
    position = () => new TraitTypeSelect({
        default: 'static' /*
      label: 'Position',
      init: 'absolute',
      select: [['static'], ['relative'], ['fixed'], ['absolute']] */,
    });
    float = () => new TraitTypeSelect( /* {
      default: 'none'
      label: 'Float',
      init: 'right',
      select: [['none'], ['left'], ['right']]
    } */);
    clear = () => new TraitTypeSelect( /*{
      default: 'none'
        label: 'Clear',
      init: 'right',
      select: [['none'], ['left'], ['right'], ['both']]
    }*/);
    left = () => new TraitTypeNumericWithSlider({
        /* label: 'Position →',
        min: 0,
        max: 1000,
        aspectsTemplate: { core: ['translateFixpoint'] }, */
        css: ({ at, aspect }) => [{ k: 'left', v: calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectWidthInPixel) }],
    });
    top = () => new TraitTypeNumericWithSlider({
        /*  label: 'Position ↓',
        min: 0,
        max: 1000,
        aspectsTemplate: { core: ['translateFixpoint'] }, */
        css: ({ at, aspect }) => [{ k: 'top', v: calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectHeightInPixel) }],
    });
    right = () => new TraitTypeNumericWithSlider({
        /* label: 'Position →',
              min: 0,
              max: 1000,
              aspectsTemplate: { core: ['translateFixpoint'] }, */
        css: ({ at, aspect }) => [{ k: 'right', v: calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectWidthInPixel) }],
    });
    bottom = () => new TraitTypeNumericWithSlider({
        /*  label: 'Position ↓',
              min: 0,
              max: 1000,
              aspectsTemplate: { core: ['translateFixpoint'] }, */
        css: ({ at, aspect }) => [{ k: 'bottom', v: calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectHeightInPixel) }],
    });
    width = () => new TraitTypeNumericWithSlider({
        // default: 10,
        roundDecimals: 0,
        /* label: 'Breite',
        min: 0,
        max: 1000, */
    });
    height = () => new TraitTypeNumericWithSlider({
        /*  label: 'Höhe',
        min: 0,
        max: 1000, */
        // default: 50,
        roundDecimals: 0,
    });
    minWidth = () => new TraitTypeNumericWithSlider({
    /*  label: 'Mindestbreite',
    min: 0,
    max: 1000,
    roundDecimals: 0 */
    });
    minHeight = () => new TraitTypeNumericWithSlider({
        /*  label: 'Mindesthöhe',
        min: 0,
        max: 1000, */
        roundDecimals: 0,
    });
    maxWidth = () => new TraitTypeNumericWithSlider({
        /*  label: 'Maximalbreite',
        min: 0,
        max: 1000, */
        roundDecimals: 0,
    });
    maxHeight = () => new TraitTypeNumericWithSlider({
        /* label: 'Maximalhöhe',
        min: 0,
        max: 1000, */
        roundDecimals: 0,
    });
    padding = () => new TraitTypeNumericWithSlider({
        /* label: 'Innenabstand',
        min: 0,
        max: 200,
        aspectsTemplate: { core: ['paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom'] }, */
        roundDecimals: 0,
        css({ at }) {
            return ['paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom'].map(k => ({
                k,
                v: at.activeOf[k] ? at.scaledValueOf[k] : at.trait.value,
            }));
        },
    });
    paddingLeft = () => new TraitTypeNumericWithSlider({
        /* label: 'Innenabstand (links)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    paddingRight = () => new TraitTypeNumericWithSlider({
        /*  label: 'Innenabstand (rechts)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    paddingTop = () => new TraitTypeNumericWithSlider({
        /*  label: 'Innenabstand (oben)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    paddingBottom = () => new TraitTypeNumericWithSlider({
        /* label: 'Innenabstand (unten)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    margin = () => new TraitTypeNumericWithSlider({
        /*  label: 'Außenabstand',
        aspectsTemplate: { core: ['marginLeft', 'marginTop', 'marginRight', 'marginBottom'] }, */
        roundDecimals: 0,
    });
    marginLeft = () => new TraitTypeNumericWithSlider({
        /*  label: 'Außenabstand (links)',
        min: -400,
        max: 400, */
        roundDecimals: 0,
    });
    marginRight = () => new TraitTypeNumericWithSlider({
        roundDecimals: 0,
        /*  label: 'Außenabstand (rechts)',
        min: -400,
        max: 400 */
    });
    marginTop = () => new TraitTypeNumericWithSlider({
        roundDecimals: 0,
        /*  label: 'Außenabstand (oben)',
        min: -200,
        max: 200 */
    });
    marginBottom = () => new TraitTypeNumericWithSlider({
        // label: 'Außenabstand (unten)',
        roundDecimals: 0,
    });
    border = () => new TraitTypeSelectWithPreview({
        /*  label: 'Rahmen',
        default: 'none',
        init: 'custom',
        select: [['none'], ['custom'], ['1px solid #CCCCCC'], ['5px solid green']],
        aspectsTemplate: { core: ['borderWidth', 'borderColor', 'borderStyle', 'borderRadius'] }, */
        css({ at }) {
            const cssPairs = [];
            if (at.activeOf.borderRadius) {
                cssPairs.push({ k: 'borderRadius', v: at.scaledValueOf.borderRadius });
            }
            if (at.trait.value !== 'custom') {
                cssPairs.push({ k: this.key, v: at.trait.value });
            }
            else {
                cssPairs.push({
                    k: this.key,
                    v: `${at.scaledValueOf.borderWidth}px ${at.valueOf.borderStyle} ${at.valueOf.borderColor}`,
                });
            }
            return cssPairs;
        },
    });
    borderBottom = () => this.border();
    borderLeft = () => this.border();
    borderRight = () => this.border();
    borderTop = () => this.border();
    outline = () => new TraitTypeSelect( /*{
      label: 'Outline',
      default: 'none',
      select: [['none'], ['1px solid #CCCCCC']]
    } */);
    borderColor = () => new TraitTypeColor({
        //  label: 'Rahmen Farbe',
        default: '#CCC',
    });
    outlineColor = () => new TraitTypeColor( /*{
        label: 'Outline Farbe'
      }*/);
    borderWidth = () => new TraitTypeNumericWithSlider({
        /*  label: 'Rahmen Breite',
        min: 0,
        max: 100, */
        default: 1,
        roundDecimals: 0,
    });
    outlineWidth = () => new TraitTypeNumericWithSlider({
        /*  label: 'Outline Breite',
        min: 0,
        max: 100, */
        roundDecimals: 0,
    });
    borderRadius = () => new TraitTypeNumericWithSlider({
        /*  label: 'Rahmen Rundung',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    borderStyle = () => new TraitTypeSelect({
        default: 'solid' /*
      label: 'Rahmen Linie',
      select: [
        ['solid', 'Linie'],
        ['dotted', 'gepunktet'],
        ['double', 'doppelt'],
        ['dashed', 'gestrichelt'],
        ['none', 'Kein'],
        ['groove'],
        ['ridge'],
        ['inset'],
        ['outset']
      ] */,
    });
    outlineStyle = () => new TraitTypeSelect({
        default: 'solid',
    });
    borderTopRightRadius = () => new TraitTypeNumericWithSlider({
        /*  label: 'Rahmen Rundung (oben rechts)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    borderTopLeftRadius = () => new TraitTypeNumericWithSlider({
        /*  label: 'Rahmen Rundung (oben links)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    borderBottomRightRadius = () => new TraitTypeNumericWithSlider({
        /*  label: 'Rahmen Rundung (unten rechts)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    borderBottomLeftRadius = () => new TraitTypeNumericWithSlider({
        /* label: 'Rahmen Rundung (unten links)',
        min: 0,
        max: 200, */
        roundDecimals: 0,
    });
    boxShadow = () => new TraitTypeSelectWithPreview({
        /*  label: 'Box Schatten',
        default: 'none',
        select: () => runtime.editChunks.traitStyleSelects.boxShadows || [],
        aspectsTemplate: {
          core: ['boxShadowH', 'boxShadowV', 'boxShadowBlur', 'boxShadowSpread', 'boxShadowColor', 'boxShadowInset']
        }, */
        css({ at }) {
            if (at.trait.value !== 'custom')
                return [{ k: 'boxShadow', v: at.trait.value }];
            let v = `${at.scaledValueOf.boxShadowH}px ${at.scaledValueOf.boxShadowV}px ${at.scaledValueOf.boxShadowBlur}px ${at.scaledValueOf.boxShadowSpread}px ${at.valueOf.boxShadowColor}`;
            if (at.activeOf.boxShadowInset) {
                v = `${at.valueOf.boxShadowInset} ${v}`;
            }
            return [
                {
                    v,
                    k: 'boxShadow',
                },
            ];
        },
    });
    boxShadowH = () => new TraitTypeNumericWithSlider({
        /* label: 'Schatten Horizontal',
        hidden: true,
        min: 0,
        max: 60, */
        roundDecimals: 0,
    });
    boxShadowV = () => new TraitTypeNumericWithSlider({
        /*  label: 'Schatten Vertikal',
        hidden: true,
        min: 0,
        max: 60, */
        roundDecimals: 0,
    });
    boxShadowBlur = () => new TraitTypeNumericWithSlider({
        /*   label: 'Schatten Blur',
        hidden: true,
        min: 0,
        max: 60, */
        default: 5,
        roundDecimals: 0,
    });
    boxShadowSpread = () => new TraitTypeNumericWithSlider({
        /*   label: 'Schatten Spread',
        hidden: true,
        min: 0,
        max: 60, */
        default: 5,
        roundDecimals: 0,
    });
    boxShadowColor = () => new TraitTypeColor( /*{
        label: 'Schatten Farbe',
        hidden: true
      } */);
    boxShadowInset = () => new TraitTypeSelect( /*{
      label: 'Schatten innen/außen',
      init: 'inset'
      select: [['', 'außen'], ['inset', 'innen']]
    }*/);
    boxSizing = () => new TraitTypeSelect( /*{
      default:
        'content-box'
      init: 'border-box',
      label: 'Box Messart',
      select: [['border-box', 'Mit Rahmen'], ['content-box', 'Ohne Rahmen']]
    }*/);
    columnCount = () => new TraitTypeNumeric();
    columnWidth = () => new TraitTypeNumericWithSlider();
    columnGap = () => new TraitTypeNumeric();
    rowGap = () => new TraitTypeNumeric();
    gridGap = () => new TraitTypeNumeric();
    gridTemplateColumns = () => new TraitTypeSelect( /*{
        init: 'inset'
        select: [['', 'außen'], ['inset', 'innen']]
      }*/);
    resize = () => new TraitTypeSelect({});
}
